import React from "react";
import "./PrivacyPolicy.css";

const PrivacyPolicy = () => {
  return (
    <div className="vp-privacy-wrapper">
      <div className="vp-privacy-container">
        <h1 className="vp-privacy-title anim anim-bottom">Privacy Policy</h1>

        <p>
          At Vangal Dairies and Gopika Agro Products Pvt. Ltd., we value your
          privacy and are committed to protecting your personal information. This
          Privacy Policy explains how we collect, use, and safeguard your data when
          you visit our website or interact with our services.
        </p>

        <h2>1. Information We Collect</h2>
        <p>We may collect the following types of information:</p>
        <ul className="no-bullets">
          <li>Personal details such as name, phone number, email address.</li>
          <li>Information submitted through contact forms.</li>
          <li>Usage data such as IP address, browser type, device information, and pages visited.</li>
          <li>Cookies to enhance user experience and website performance.</li>
        </ul>

        <h2>2. How We Use Your Information</h2>
        <p>Your information may be used for:</p>
        <ul className="no-bullets">
          <li>Responding to your enquiries or customer support requests.</li>
          <li>Improving website performance, security, and user experience.</li>
          <li>Sending updates or information related to our products (only with consent).</li>
          <li>Internal analytics and operational improvements.</li>
        </ul>

        <h2>3. Data Protection & Security</h2>
        <p>
          We implement reasonable technical and administrative security measures to
          protect your personal data from unauthorized access, misuse, or loss.
        </p>

        <h2>4. Sharing of Information</h2>
        <p>
          We do NOT sell or rent your data. Information may be shared only with:
        </p>
        <ul className="no-bullets">
          <li>Service providers who help operate the website.</li>
          <li>Authorities if required by law or for legal compliance.</li>
        </ul>

        <h2>5. Cookies</h2>
        <p>
          Our website uses cookies to enhance user experience. You may disable
          cookies in your browser, but certain features may not function properly.
        </p>

        <h2>6. Links to External Websites</h2>
        <p>
          Our website may contain links to external sites. We are not responsible
          for the content or privacy practices of those websites.
        </p>

        <h2>7. Children's Privacy</h2>
        <p>
          We do not knowingly collect information from children under the age of 13.
        </p>

        <h2>8. Changes to This Policy</h2>
        <p>
          We may update this Privacy Policy periodically. Changes will be posted on
          this page with an updated revision date.
        </p>

        <h2>9. Contact Us</h2>
        <p>
          For questions regarding this Privacy Policy or your data rights, you may
          contact us through our official support email or the contact page on our
          website.
        </p>
      </div>
    </div>
  );
};

export default PrivacyPolicy;
